<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12" md="auto">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
      <v-spacer/>
      <v-col cols="12" md="auto">
        <v-text-field
          v-model="keyword"
          filled
          dense
          flat
          solo
          clearable
          label="Tìm cơ sở"
          placeholder="Vd: tên cơ sở, loại hình, ..."
          prepend-inner-icon="mdi-magnify" 
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="auto">
        <v-btn-toggle
          color="primary"
          dense
          group
        >
          <v-btn
            :to="{ name: 'Business' }"
            exact
            text
          >
            <v-icon>mdi-view-grid</v-icon>
          </v-btn>
          <v-btn
            :to="{ name: 'BusinessTypeView', params: { view: 'map' }}"
            exact
            text
          >
            <v-icon>mdi-map</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="areaSelected"
          v-on:change="filterBusiness"
          :items="areas"
          item-text="name"
          item-value="maqh"
          label="Lọc theo khu vực"
          prepend-inner-icon="mdi-filter"
          multiple
          filled
          dense
          flat
          solo
          clearable
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="sortSelected"
          v-on:change="filterBusiness"
          :items="sorts"
          filled
          dense
          flat
          solo
          clearable
          label="Sắp xếp theo"
          prepend-inner-icon="mdi-sort-alphabetical-variant"
          hide-details 
        />
      </v-col>
    </v-row>
    <component :is="useComponent" :filterObj="params" />
  </v-container>
</template>
<script>
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  import BusinessGridView from '@/views/public/business/BusinessGridView';
  import BusinessMapView from '@/views/public/business/BusinessMapView';
  export default {
    components: { 
      BaseBreadcrumbs,
      BusinessGridView,
      BusinessMapView,
    },
    data () {
      return {
        crumbs: [],
        sorts: [
          {value: 'asc', text: 'A-Z'},
          {value: 'desc', text: 'Z-A'}
        ],
        sortSelected: null,
        keywordInput: '',
        params: {
          areas: null,
          keyword: null,
          sort: null
        },
        timeout: null,
        areas: [],
        areaSelected: null
      }
    },
    computed: {
      useComponent() {
        if (this.$route.params.view === 'map') 
          return BusinessMapView;
        return BusinessGridView;
      },
      keyword: {
        get() {
          return this.keywordInput;
        },
        set(val) {
          if (this.timeout) clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            this.keywordInput = val;
            this.setParams();
          }, 1000)
        }
      }
    },
    mounted () {
      this.getAreas();
      this.crumbs = [
        {
          text: 'Trang chủ',
          disabled: false,
          href: '/',
        },
        {
          text: 'Cơ sở sản xuất, kinh doanh',
          disabled: true
        }
      ];
    },
    methods: {
      getAreas () {
        axios.get("api/v1/public/get-district-by-province")
          .then(response => {
            this.areas = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      setParams(){
        let params = {};

        if (this.areaSelected) {
          params["areas"] = this.areaSelected;
        }

        if (this.keywordInput) {
          params["keyword"] = this.keywordInput;
        }

        if (this.sortSelected) {
          params["sort"] = this.sortSelected;
        }
        this.params = params;
      },
      filterBusiness(){
        this.setParams();
      }
    }
  }
</script>
<style>
  .v-btn-toggle--group > .v-btn {
    margin: 0 4px;
  }
  .v-btn-toggle--dense > .v-btn {
    padding: 19px 8px;
  }
</style>